export const BUSINESS_TYPES = [
  { id: 'feed', name: 'Feed Supplier' },
  { id: 'equipment', name: 'Equipment & Supplies' },
  { id: 'medication', name: 'Medication & Vaccines' },
  { id: 'hatchery', name: 'Hatchery (Day-old Chicks)' },
  { id: 'veterinary', name: 'Veterinary Services' },
  { id: 'other', name: 'Other' }
];

const NAME_BY_ID = Object.fromEntries(BUSINESS_TYPES.map((t) => [t.id, t.name]));

export function normalizeBusinessTypes(supplier) {
  if (Array.isArray(supplier?.businessTypes) && supplier.businessTypes.length) {
    return supplier.businessTypes.filter((id) => NAME_BY_ID[id]);
  }
  const single = supplier?.businessType || supplier?.business_type;
  return NAME_BY_ID[single] ? [single] : [];
}

export function formatBusinessTypes(supplier) {
  const ids = normalizeBusinessTypes(supplier);
  if (!ids.length) return 'Supplier';
  return ids.map((id) => NAME_BY_ID[id] || id).join(' · ');
}
